import { Configuration, MemberTaskList, MemberTasksApi } from '@dialogue/silkroad'
import axios from 'axios'
import { call, select, SagaGenerator } from 'typed-redux-saga'

import Config from 'APP/Config'
import { isAccessTokenValid } from 'APP/Lib/AuthHelpers'
import { serviceHeaders } from 'APP/Lib/ServiceHeaders'
import { RootState } from 'APP/Store/CreateStore'
import { keepSupportedTasksOnly } from './mapper'
import { MemberTask } from './types'

export const selectAccessToken = (state: RootState) => state.login.accessToken

const createMemberTasksApi = (accessToken: string | null): MemberTasksApi => {
  if (!Config.SILKROAD_DOMAIN) {
    throw new Error('Unable to connect to Silkroad. No base URL provided.')
  }
  if (!isAccessTokenValid(accessToken)) {
    throw new Error('Unable to connect to Silkroad. Access token is not valid.')
  }

  const configuration = new Configuration({
    basePath: Config.SILKROAD_DOMAIN,
    accessToken,
    baseOptions: { headers: serviceHeaders },
  })

  return new MemberTasksApi(configuration, undefined, axios)
}

export async function fetchRawNextTasks(
  accessToken: string | null,
  episodeId?: string
): Promise<MemberTaskList> {
  const api = createMemberTasksApi(accessToken)
  const { data } = await api.nextTasks({ episode_id: episodeId })
  return data
}

export function* getNextTasks(episodeId?: string): SagaGenerator<MemberTask[]> {
  const accessToken = yield* select(selectAccessToken)
  const raw = yield* call(fetchRawNextTasks, accessToken, episodeId)
  return keepSupportedTasksOnly(raw)
}
